import { computed, ref } from 'vue'

import type { Ref, ComputedRef } from 'vue'
import type { NativeSelectOption } from '@shared/ui/fields'

import { CategoryStrict } from '../enums'

interface FilterStrictCategoryOptions {
  initial: string | null
}

interface FilterStrictCategoryReturn {
  options: ComputedRef<NativeSelectOption[]>
  query: Ref<string | null>
  handleChange: (option: NativeSelectOption) => void
}

export const useFilterStrictCategory = ({ initial }: FilterStrictCategoryOptions): FilterStrictCategoryReturn => {
  const query = ref<string | null>(initial ?? CategoryStrict.NotStrict)

  const options = computed<NativeSelectOption[]>(() => {
    const list: Record<string, string> = {
      [CategoryStrict.NotStrict]: 'Not strict',
      [CategoryStrict.Strict]: 'Strict',
    }

    return Object.entries(list).map(([id, text]) => ({
      id,
      value: id,
      text,
      selected: id === query.value,
    }))
  })

  const handleChange = (option: NativeSelectOption): void => {
    query.value = String(option.value)
  }

  return {
    options,
    query,
    handleChange,
  }
}
